import React, { useCallback, useEffect, useState } from 'react';
import { Space, Modal } from 'antd';
import { DeleteOutlined, EditOutlined, ExclamationCircleFilled } from "@ant-design/icons"
import AddProduct from '../components/AddProduct';
import { deleteData, getData } from '../helpers/api';
import { openNotification } from '../helpers/alerts';
import TableLayout from '../components/layouts/TableLayout';
import withRoleProtection from '../components/withRoleProtection';

const { confirm } = Modal;
const INITIAL_VALUE = {
    name: '',
    price: null,
    stock: 0
}
const Products = () => {
    const [addProductModal, setAddProductModal] = useState(false)
    const [product, setProduct] = useState(INITIAL_VALUE)
    const [products, setProducts] = useState([])

    const columns = [
        {
            title: 'Produit',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Prix',
            dataIndex: 'price',
            key: 'price',
        },
        {
            title: 'Stock',
            dataIndex: 'stock',
            key: 'stock',
        },
        {
            title: 'Action',
            key: 'action',
            render: (_, record) => (
                <Space size="middle">
                    <span>
                        <DeleteOutlined
                            onClick={() => showDeleteConfirm(record.id)}
                        />
                    </span>
                    <span>
                        <EditOutlined
                            onClick={() => {
                                setProduct(record)
                                setAddProductModal(true)
                            }}
                        />
                    </span>
                </Space>
            ),
        },
    ];

    useEffect(() => {
        getProducts()
    }, [])

    const handleAfterAddingProduct = useCallback(() => {
        setAddProductModal(false)
        getProducts()
    }, [])

    const getProducts = async () => {
        try {
            const res = await getData("/products");
            setProducts(res.data)
        } catch (error) {
            console.log("erreur")
        }
    }

    const showDeleteConfirm = (productId) => {
        confirm({
            title: 'Vous êtes sûr de supprimer ce produit ?',
            icon: <ExclamationCircleFilled />,
            okText: 'Suprimer',
            okType: 'danger',
            cancelText: 'Anuler',
            onOk() {
                deleteProduct(productId)
            },
        });
    };

    const deleteProduct = async (productId) => {
        try {
            await deleteData(`/products/${productId}`)
            getProducts()
        } catch (error) {
            openNotification(`Erreurs côté serveur`, 'error')
        }
    }

    const handleCancel = () => {
        setProduct(INITIAL_VALUE);
        setAddProductModal(false);
    }
    return (
        <>
            {addProductModal && <AddProduct
                handleAfterAddingProduct={handleAfterAddingProduct}
                initialValue={product}
                isModalOpen={addProductModal}
                handleCancel={handleCancel}
            />}
            <TableLayout
                columns={columns}
                dataSource={products}
                setAddElementModal={setAddProductModal}
            />
        </>
    );
}

export default withRoleProtection(Products, ['super admin']);